import { render, staticRenderFns } from "./ManageTeamMemberForm.vue?vue&type=template&id=c5400a34&scoped=true&"
import script from "./ManageTeamMemberForm.vue?vue&type=script&lang=js&"
export * from "./ManageTeamMemberForm.vue?vue&type=script&lang=js&"
import style0 from "./ManageTeamMemberForm.vue?vue&type=style&index=0&id=c5400a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5400a34",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QIcon});
